var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommentRegular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5C5.37192 0.5 0.00131835 4.86406 0.00131835 10.25C0.00131835 12.4827 0.934599 14.5273 2.48147 16.1656C1.78397 18.0172 0.331318 19.5819 0.307881 19.5992C-0.002666 19.9273 -0.0846973 20.4078 0.091084 20.818C0.272762 21.2281 0.674106 21.5 1.12504 21.5C4.00786 21.5 6.23911 20.293 7.64536 19.332C8.95786 19.7562 10.4672 20 12 20C18.6282 20 23.9579 15.6345 23.9579 10.25C23.9579 4.86547 18.6282 0.5 12 0.5ZM12.0047 17.75C10.7508 17.75 9.51473 17.5566 8.33067 17.1819L7.26426 16.8479L6.3502 17.4924C5.68223 17.9668 4.76207 18.4946 3.65489 18.8518C4.00059 18.2837 4.32848 17.6448 4.58676 16.9651L5.08457 15.6526L4.11801 14.6274C3.27286 13.7234 2.25332 12.2281 2.25332 10.25C2.25332 6.11328 6.62442 2.75 12.0033 2.75C17.3822 2.75 21.7533 6.11328 21.7533 10.25C21.7533 14.3867 17.3813 17.75 12.0047 17.75Z",
    fill: "#1A2021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentRegular);
export default __webpack_public_path__ + "static/media/comment-regular.0f270acda9c83d7e2165fdb1cf67729a.svg";
export { ForwardRef as ReactComponent };